import React, {useEffect, useState} from 'react';
import Head from 'next/head';
import Axios from 'axios';
import getMetaTagData from '../../../src/common/services/getMetaTagData';
import ServiceNotice from '../../../src/component/pc/pass/ServiceNotice';

import cookieCutter from 'cookie-cutter';
import {getLnbList, goLogin, getBillingUrl} from "../../../src/common/utils/passUtil";

function Sbsmoney({ metaTagData, moneyData }) {

    //jwt 토큰 관리
    const [login_jwt, setLogin_jwt] = useState();
    const [platform, setPlatform] = useState();

    //화면시작시 최초 한번 시작...
    useEffect(async () => {
        window.scrollTo(0, 0);
        const LOGIN_JWT = cookieCutter.get('LOGIN_JWT'); //로그인 토큰 가져오는 부분
        const platformCookie = cookieCutter.get('JOIN_PLATFORM');

        setLogin_jwt(LOGIN_JWT);
        setPlatform(platformCookie);

    }, []);

    const billingUrl = getBillingUrl(login_jwt,'pc', 'money', '')
    const option = 'width=570,height=800,resizable=yes,scrollbars=yes'
    const target = 'Billing'

    return (
        <>
            <Head>
                <link key='css_pc_url' rel='stylesheet' href={process.env.NEXT_PUBLIC_GLOBAL_CSS_2023_PC_PASSMONEY_URL} />
                <meta key='viewport' name='viewport' content='width=device-width, initial-scale=1' />
                <script key='gnb_js_url' type='text/javascript' src={process.env.NEXT_PUBLIC_GNB_JS_URL} />
                <script src='//developers.kakao.com/sdk/js/kakao.min.js' />
                <meta name='description' content={metaTagData.shareDescription} />
                <meta name='keywords' content={metaTagData.keywords} />
                <meta name='twitter:card' content='summary' />
                <noscript>Your browser does not support JavaScript!</noscript>
                <meta property='og:type' content='website' />
                <meta property='og:locale' content='ko_KR' />
                <meta property='og:site_name' content='SBS' />
                <meta property='og:title' content={metaTagData.shareTitle || ''} />
                <meta property='og:description' content={metaTagData.shareDescription || ''} />8
                <meta property='og:image' content={metaTagData.shareImageUrl || ''} />
                <meta property='og:url' content={metaTagData.currentUrl || ''} />
                <meta name='nate:site_name' content='SBS' />
                <meta name='nate:title' content={metaTagData.shareTitle || ''} />
                <meta name='nate:description' content={metaTagData.shareDescription || ''} />
                <meta name='nate:image' content={metaTagData.shareImageUrl || ''} />
                <meta name='nate:url' content={metaTagData.currentUrl || ''} />
                <title>{metaTagData.shareTitle}</title>
            </Head>

            <div id="container" className="contents">
                <div className="passmoneyContents">
                    {getLnbList('pc')}
                    <div className="passmoneyCont_money">
                        <div className="curationBannerWrap" style={{backgroundColor:'#AB6BE2'}}>
                            <img src="/images/pass/moneyBnr.png" className="curationBanner" alt="SBS머니는 유료 서비스를 이용할 수 있는 사이버머니 입니다!"/>
                        </div>
                        <div className="moneyContents">
                            <p className="moneyTextCont">VOD 시청할 때마다 매번 결제하기 번거로우셨다면<br/>SBS머니로 한 번에 충전하고 편하게 시청하세요!</p>
                            <a className="btnLineType_money" href="#none" onClick={() => login_jwt ? window.open(billingUrl, target, option) : window.location.href=goLogin()}>충전하기</a>
                        </div>
                        {moneyData.service_notice && (<div className="noticeList_wrap"><ServiceNotice data={moneyData.service_notice}/></div>)}
                    </div>
                </div>
            </div>
        </>
    );
}

const getMoneyData = async () => {
    let result = null;

    //console.log('NEXT_PUBLIC_API_MONEY_KO :>> ', process.env.NEXT_PUBLIC_API_MONEY_KO);

    try {
        const moneyData = await Axios.get(process.env.NEXT_PUBLIC_API_MONEY_KO, { timeout: 3000 });
        result = moneyData.data ? { ...moneyData.data } : null;

        //console.log(result);

    } catch (error) {
        console.error(error);
        result = null;
    }

    return result;
};

export async function getServerSideProps(ctx) {

    //console.log('getServerSideProps');
    // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
    const { cookies } = ctx.req;
    const { LOGIN_JWT } = cookies;
    const { JOIN_PLATFORM } = cookies;
    const { pageSection, pageCategory } = ctx.query;

    let metaTagData;
    let moneyData;

    try {
        metaTagData = getMetaTagData(ctx.req.url, 'money', pageCategory); // 메타 데이터 불러오는 부분(각페이지마다 있어야함)
        moneyData = await getMoneyData();
    } catch (error) {
        console.error(error);
    }

    return {
        props:{
            moneyData: moneyData,
            metaTagData
        }
    };
}

export default Sbsmoney;